import { render } from "./ProjectsTab.vue?vue&type=template&id=7adf96b1"
import script from "./ProjectsTab.vue?vue&type=script&lang=js"
export * from "./ProjectsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__